import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  CircularProgress,
  MenuItem,
  Alert,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../DataLayouts/Header";
import toast from "react-hot-toast";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import { MAIN_URL } from "../../../Configurations/Urls";
import { fetchPayrollComponents, fetchSalaryStructure } from "../../../Apis/Payroll";

const toList = (value) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.data)) return value.data;
  return [];
};

const getSalaryStructureLabel = (option) => {
  const cycleName =
    option?.payroll_cycle?.payroll_cycle_name ||
    option?.PayrollCycle?.payroll_cycle_name ||
    (typeof option?.payroll_cycle === "string" ? option.payroll_cycle : "");

  const employeeCode =
    option?.employee?.employee_code ||
    option?.employee_code ||
    "";

  const employeeName = option?.employee_name || "";

  const basis = option?.salary_basis || "";
  const monthly = option?.monthly_salary_amount;

  const parts = [
    employeeName || employeeCode,
    cycleName,
    basis,
    monthly != null && monthly !== "" ? `₹${monthly}` : "",
  ].filter(Boolean);

  if (parts.length > 0) {
    return parts.join(" - ");
  }

  return `Salary Structure #${option?.organization_payroll_employee_salary_structure_id ?? ""}`;
};

const clearCalculationFields = (method) => {
  const cleared = {
    fixed_amount: "",
    percentage_value: "",
    percentage_of_component: "",
    custom_formula_json: "",
  };

  switch (method) {
    case "Fixed":
      delete cleared.fixed_amount;
      break;
    case "Percentage":
      delete cleared.percentage_value;
      delete cleared.percentage_of_component;
      break;
    case "Formula":
      delete cleared.custom_formula_json;
      break;
    default:
      break;
  }

  return cleared;
};

const buildPayload = (data) => {
  const payload = {
    organization_payroll_employee_salary_structure_id:
      data.organization_payroll_employee_salary_structure_id,
    organization_payroll_component_id: data.organization_payroll_component_id,
    calculation_method: data.calculation_method,
    sort_order: data.sort_order !== "" ? Number(data.sort_order) : null,
    is_active: data.is_active !== false && data.is_active !== "0",
    fixed_amount: null,
    percentage_value: null,
    percentage_of_component: null,
    custom_formula_json: null,
  };

  switch (data.calculation_method) {
    case "Fixed":
      payload.fixed_amount =
        data.fixed_amount !== "" ? Number(data.fixed_amount) : null;
      break;
    case "Percentage":
      payload.percentage_value =
        data.percentage_value !== "" ? Number(data.percentage_value) : null;
      payload.percentage_of_component = data.percentage_of_component || null;
      break;
    case "Formula":
      payload.custom_formula_json = data.custom_formula_json || null;
      break;
    case "Inherit":
    case "Slab":
    default:
      break;
  }

  return payload;
};

function SalaryStructureComponentForm({ mode }) {
  const { id } = useParams(); // only used in edit mode
  const { userData } = useAuthStore();
  const org = userData?.organization;

  const [formData, setFormData] = useState({
    organization_payroll_employee_salary_structure_id: "",
    organization_payroll_component_id: "",
    calculation_method: "",
    fixed_amount: "",
    percentage_value: "",
    percentage_of_component: "",
    custom_formula_json: "",
    sort_order: "",
    is_active: "",
  });






  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(mode === "edit");
  const [btnLoading, setbtnLoading] = useState(false);
  const [structure , setStructure]=useState([])
  const [component, setComponent]=useState([]);

  let navigate = useNavigate();

    const MAX_INCREMENT = 999999999.99;


    useEffect(() => {
      if (!org?.organization_id) return;

      fetchSalaryStructure(org.organization_id)
        .then((data) => {
          setStructure(toList(data?.payroll ?? data));
        })
        .catch((err) => {
          console.error("Failed to fetch salary structures:", err);
          setStructure([]);
          toast.error(err.message || "Failed to fetch salary structures");
        });
    }, [org?.organization_id]);

    useEffect(() => {
      if (!org?.organization_id) return;

      fetchPayrollComponents(org.organization_id)
        .then((data) => {
          setComponent(toList(data?.payrollComponent ?? data));
        })
        .catch((err) => {
          console.error("Failed to fetch payroll components:", err);
          setComponent([]);
          toast.error(err.message || "Failed to fetch payroll components");
        });
    }, [org?.organization_id]);



  useEffect(() => {
    let getdataById = async () => {
      try {
        const response = await axios.get(
          `${MAIN_URL}/api/organizations/${org.organization_id}/payroll/salary-component/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        let a = response?.data?.payroll || response?.data?.Salary;
        if (a) {
          setFormData(a);
        }
        setLoading(false);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load salary component data.");
        setLoading(false);
      }
    };
    if (mode === "edit" && id && org?.organization_id) {
      setLoading(true);
      getdataById();
    }
  }, [mode, id, org?.organization_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "calculation_method") {
      setFormData((prev) => ({
        ...prev,
        calculation_method: value,
        ...clearCalculationFields(value),
      }));
      setFormErrors((prev) => ({
        ...prev,
        calculation_method: "",
        fixed_amount: "",
        percentage_value: "",
        percentage_of_component: "",
        custom_formula_json: "",
      }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.organization_payroll_employee_salary_structure_id)
      errors.organization_payroll_employee_salary_structure_id =
        "Salary structure is required.";

    if (!formData.organization_payroll_component_id)
      errors.organization_payroll_component_id =
        "Payroll component is required.";

    if (!formData.calculation_method)
      errors.calculation_method = "Calculation method is required.";

    switch (formData.calculation_method) {
      case "Fixed":
        if (!formData.fixed_amount && formData.fixed_amount !== 0) {
          errors.fixed_amount = "Fixed amount is required.";
        }
        break;
      case "Percentage":
        if (!formData.percentage_value && formData.percentage_value !== 0) {
          errors.percentage_value = "Percentage value is required.";
        }
        if (!formData.percentage_of_component?.trim()) {
          errors.percentage_of_component = "Percentage of component is required.";
        }
        break;
      case "Formula":
        if (!formData.custom_formula_json?.trim()) {
          errors.custom_formula_json = "Custom formula JSON is required.";
        } else {
          try {
            JSON.parse(formData.custom_formula_json);
          } catch {
            errors.custom_formula_json = "Custom formula JSON must be valid JSON.";
          }
        }
        break;
      case "Inherit":
      case "Slab":
      default:
        break;
    }

    setFormErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setbtnLoading(true);

    const payload = buildPayload(formData);

    try {
      if (mode === "edit") {
        await axios.put(
          `${MAIN_URL}/api/organizations/${org.organization_id}/payroll/salary-component/${id}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      } else {
        await axios.post(
          `${MAIN_URL}/api/organizations/${org.organization_id}/payroll/salary-component`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      }
      toast.success(
        mode === "edit"
          ? "Payroll Salary Structure Component  updated!"
          : "Payroll Salary Structure Component  created!"
      );
      setFormErrors({});
      navigate(-1);
    } catch (err) {
      console.error(err);
      if (err.response?.status === 422) {
        const validationErrors = err.response.data.errors || {};
        setFormErrors(validationErrors);
        const errorMessages = Object.values(validationErrors)
          .map((arr) => arr[0])
          .join(" ");
        toast.error(errorMessages || "Validation failed.");
      } else {
        toast.error("Something went wrong.");
      }
    } finally {
      setbtnLoading(false);
    }
  };

  const renderCalculationFields = () => {
    switch (formData.calculation_method) {
      case "Inherit":
        return (
          <Grid item xs={12}>
            <Alert severity="info">
              Values are inherited from the selected payroll component configuration.
            </Alert>
          </Grid>
        );
      case "Fixed":
        return (
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Fixed Amount"
              name="fixed_amount"
              type="number"
              value={formData?.fixed_amount ?? ""}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d*$/.test(value)) {
                  if (value === "" || Number(value) <= MAX_INCREMENT) {
                    handleChange(e);
                  }
                }
              }}
              error={!!formErrors.fixed_amount}
              helperText={formErrors.fixed_amount}
              required
              disabled={mode === "view"}
              inputProps={{ min: 0, max: MAX_INCREMENT }}
            />
          </Grid>
        );
      case "Percentage":
        return (
          <>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Percentage Value"
                name="percentage_value"
                type="number"
                value={formData?.percentage_value ?? ""}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d*$/.test(value)) {
                    if (value === "" || Number(value) <= MAX_INCREMENT) {
                      handleChange(e);
                    }
                  }
                }}
                error={!!formErrors.percentage_value}
                helperText={formErrors.percentage_value}
                required
                disabled={mode === "view"}
                inputProps={{ min: 0, max: MAX_INCREMENT }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Percentage of Component"
                name="percentage_of_component"
                value={formData.percentage_of_component}
                onChange={handleChange}
                error={!!formErrors.percentage_of_component}
                helperText={formErrors.percentage_of_component || "e.g. Basic"}
                required
                disabled={mode === "view"}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
          </>
        );
      case "Formula":
        return (
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Custom Formula JSON"
              name="custom_formula_json"
              value={formData.custom_formula_json}
              onChange={handleChange}
              error={!!formErrors.custom_formula_json}
              helperText={formErrors.custom_formula_json}
              required
              disabled={mode === "view"}
              multiline
              rows={6}
            />
          </Grid>
        );
      case "Slab":
        return (
          <Grid item xs={12}>
            <Alert severity="info">
              Slab calculation uses the slab tiers defined on the selected payroll component.
            </Alert>
          </Grid>
        );
      default:
        return null;
    }
  };

  return (
    
      <Header
        mode={mode}
        updateMessage={"Salary Structure Component"}
        addMessage={"Salary Structure Component"}
        homeLink={"/payroll/salary-structure/components"}
        homeText={"Salary Structure Component"}
        onSubmit={handleSubmit}
        loading={loading}
        btnLoading={btnLoading}>
      {loading ? (
        <Grid container spacing={2}>
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label="Payroll Salary Structure"
                  name="organization_payroll_employee_salary_structure_id"
                  value={
                    formData.organization_payroll_employee_salary_structure_id
                  }
                  onChange={handleChange}
                  error={
                    !!formErrors.organization_payroll_employee_salary_structure_id
                  }
                  helperText={
                    formErrors.organization_payroll_employee_salary_structure_id
                  }
                  required
                  disabled={mode === "view"}
                >
                  {structure?.length > 0 ? (
                    structure.map((option) => (
                      <MenuItem
                        key={
                          option.organization_payroll_employee_salary_structure_id
                        }
                        value={
                          option.organization_payroll_employee_salary_structure_id
                        }
                      >
                        {getSalaryStructureLabel(option)}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled value="">
                      No salary structures found
                    </MenuItem>
                  )}
                </TextField>
                </Grid>

                <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  label="Payroll Component"
                  name="organization_payroll_component_id"
                  value={formData.organization_payroll_component_id}
                  onChange={handleChange}
                  error={!!formErrors.organization_payroll_component_id}
                  helperText={formErrors.organization_payroll_component_id}
                  required
                  disabled={mode === "view"}
                >
                  {component?.length > 0 ? (
                    component.map((option) => (
                      <MenuItem
                        key={option.organization_payroll_component_id}
                        value={option.organization_payroll_component_id}
                      >
                        {option?.payroll_component_name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled value="">
                      No payroll components found
                    </MenuItem>
                  )}
                </TextField>
                </Grid>

                <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  label="Calculation Method"
                  name="calculation_method"
                  value={formData.calculation_method}
                  onChange={handleChange}
                  error={!!formErrors.calculation_method}
                  helperText={formErrors.calculation_method}
                  required
                  disabled={mode === "view"}
                >
                  <MenuItem value="Inherit">Inherit</MenuItem>
                  <MenuItem value="Fixed">Fixed</MenuItem>
                  <MenuItem value="Percentage">Percentage</MenuItem>
                  <MenuItem value="Formula">Formula</MenuItem>
                  <MenuItem value="Slab">Slab</MenuItem>
                </TextField>
                </Grid>

                {renderCalculationFields()}

                <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Sort Order"
                  name="sort_order"
                  type="number"
                  value={formData?.sort_order ?? ""}
                  onChange={(e) => {
                    let value = e.target.value;

                    if (/^\d*$/.test(value)) {
                      if (value === "" || Number(value) <= MAX_INCREMENT) {
                        handleChange(e);
                      }
                    }
                  }}
                  error={!!formErrors.sort_order}
                  helperText={formErrors.sort_order}
                  disabled={mode === "view"}
                  inputProps={{
                    min: 0,
                    max: MAX_INCREMENT,
                    maxLength: 13,
                  }}
                />
                </Grid>

                {mode !== "view" && (
                <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  onClick={handleSubmit}
                  disabled={loading || btnLoading || mode === "view"}
                  sx={{
                    borderRadius: 2,
                    minWidth: 120,
                    textTransform: "capitalize",
                    fontWeight: 500,
                  }}
                >
                  {loading || btnLoading ? (
                    <CircularProgress size={22} sx={{ color: "#fff" }} />
                  ) : mode === "edit" ? (
                    "Submit"
                  ) : (
                    "Submit"
                  )}
                </Button>
                </Grid>
                )}
              </Grid>

              {mode === "edit" && (
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    onClick={() => navigate(-1)}
                    sx={{
                      borderRadius: 2,
                      minWidth: 120,
                      textTransform: "capitalize",
                      fontWeight: 500,
                      mt: 2,
                      backgroundColor: "#1976d2",
                      "&:hover": { backgroundColor: "#115293" },
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              )}
            </Paper>
          </Grid>
        </Grid>
      )}
    </Header>
  );
}

export default SalaryStructureComponentForm;
